import Vue from 'vue';
import { mapGetters } from 'vuex';
import Analyses from './AnalysisList.vue';
import DataFiles from './DataFiles.vue';
import Members from './Members.vue';
import IntegrationDataFiles from './IntegrationDataFiles.vue';
import BucketIntegrationDataFiles from './BucketIntegrationDataFiles.vue';
import { CLEAR_MESSAGE } from 'src/store/types';
export default Vue.extend({
    components: {
        Analyses,
        DataFiles,
        IntegrationDataFiles,
        BucketIntegrationDataFiles,
        Members
    },
    props: {
        isLoadingProject: { type: Boolean, required: false, default: true }
    },
    computed: {
        ...mapGetters([
            'isSubscribed', 'isAdmin', 'currentUser', 'currentRoute', 'currentProject', 'projectMessage'
        ]),
        projectMembers() {
            return this.currentProject?.users?.map(({ user }) => user) || [];
        },
        projectId() {
            return this.$route.params.projectId;
        },
        hasIntegration() {
            return !!this.currentProject.integration;
        },
        hasBucketIntegration() {
            return this.hasIntegration && (this.currentProject.integration.type === 's3' || this.currentProject.integration.type === 'gcs');
        },
        projectName() {
            let parts = this.currentProject.name.split(' ');
            // If there is a continuous non-spaced string n = 50, truncate it.
            // Covers ridiculous edge case.
            return parts.map(x => x.slice(0, 50)).join(' ');
        }
    },
    metaInfo() {
        return {
            title: this.currentProject ? `${this.currentProject.name} - Kapiche` : null
        };
    },
    mounted() {
        // this might want to be implemented in the store itself, rather than here
        this.$store.watch(() => {
            if (this.projectMessage) {
                // Auto-hide
                setTimeout(() => {
                    this.$store.commit(CLEAR_MESSAGE);
                }, 5000);
            }
        }, () => null);
    },
    methods: {
        fetchProject() {
            this.$emit('fetch-project');
        }
    }
});
